import { z } from 'zod';

const authenticationFakeSchema = z.literal('fake');

const authenticationOidcSchema = z.object({
  kind: z.literal('oidc'),
  authority: z.string(),
  clientId: z.string(),
});

const authenticationSchema = z.union([authenticationFakeSchema, authenticationOidcSchema]);

export const configSchema = z.object({
  authentication: authenticationSchema,
  pollingDuration: z.int().default(5000),
  // nginx serves an empty version when the image was built without one
  version: z
    .string()
    .optional()
    .transform((version) => version || undefined),
});

export type AuthenticationConfig = z.infer<typeof authenticationSchema>;

export type Config = z.infer<typeof configSchema>;
